function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M7.93 5.48l3.13 3.13c.52.52 1.37.52 1.89 0l3.13-3.13c.84-.84.25-2.29-.95-2.29H8.87c-1.19 0-1.79 1.45-.94 2.29zm0 13.04l3.13-3.13a1.34 1.34 0 011.89 0l3.13 3.13c.84.84.25 2.29-.95 2.29H8.87c-1.19 0-1.79-1.45-.94-2.29z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.16 11.43l2.29-3.6c.36-.57 1.16-.66 1.64-.18l3.6 3.6c.41.41.41 1.08 0 1.49l-3.6 3.6c-.48.48-1.27.39-1.64-.18l-2.29-3.6c-.21-.34-.21-.78 0-1.13zm19.68 0l-2.29-3.6c-.36-.57-1.16-.66-1.64-.18l-3.6 3.6c-.41.41-.41 1.08 0 1.49l3.6 3.6c.48.48 1.27.39 1.64-.18l2.29-3.6c.21-.34.21-.78 0-1.13z"
})));